// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__-C_9C","choiceBoxes":"toolbarselects_choiceBoxes__5gQvw","simpleField":"toolbarselects_simpleField__2TTY-"};